import React, {useEffect, useRef, useState} from 'react'
import {TreeItem, TreeView} from '@material-ui/lab';
import {Grid} from '@material-ui/core'
import {ChevronRight, ExpandMore} from '@material-ui/icons'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'
import Utils from "EurestoFonction/Utils";


const getDetailsFT = async (id) => {
    return await ApiRequest(project.api + 'gestion', {
        requete: 'produit',
        action: 'get',
        id: id,
    })
}
const getDetails = async (id) => {
    const r = await getDetailsFT(id)
    return r.results.details
}

export default React.memo(props => {

    const details = useRef([])

    const [key, setKey] = useState(Utils.uuidv4(), [])
    const getInfo = async (ds) => {
        await Promise.all(ds.map(async (produit, i) => {
            produit.type_produit_id && console.log('###################', produit.type_produit_id)
            if (produit.type_produit_id === 2 || produit.type_produit_id === 5) {
                const detailsFT = await getDetails(produit.produit_id)
                ds[i].details = await getInfo(detailsFT.filter(d => d.produit_id))
            }
        }))
        return ds;
    }

    useEffect(() => {
        const info = async () => {
            details.current = await getInfo(props.details.filter(d => d.produit_id))
            setKey(Utils.uuidv4())
        }
        info()
    }, [props.details])

    const treeViewItem = (detail, i, parentQ = '') => {
        const iPQ = parentQ !== ''
        return <TreeItem nodeId={i + ''}
                         label={<span>{detail.produit_libelle + ' : '}<b className={'EurestoError--text'}>{(iPQ && `${parentQ}x ` || '')
                         + detail.quantite
                         + (detail.libelle_part_unite && ('x ' + detail.part + ' ' + detail.libelle_part_unite) || detail.libelle_unite)
                         + (iPQ && `(=${Math.round(parentQ*detail.quantite*1000)/1000} ${detail.libelle_part_unite || detail.libelle_unite})` || '')}</b></span>}>
            {
                detail.details && detail.details.map((d, j) => treeViewItem(d, detail.produit_id + '-' + j,detail.quantite))
            }
        </TreeItem>

    }

    return <Grid key={key}>
        <TreeView
            multiSelect
            defaultCollapseIcon={<ExpandMore/>}
            defaultExpandIcon={<ChevronRight/>}>

            {
                details.current.map((d, i) => treeViewItem(d, i))}

        </TreeView>
    </Grid>
})


// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Arborescence/index.js